import { useCallback, useRef, useState } from 'react';
import SearchBlockInput from './SearchBlockInput';
import SearchSuggestions from './SearchSuggestions/SearchSuggestions';
import { getSearchSuggestions } from 'services';
import _debounce from 'lodash/debounce';
import { useOutsideAlerter } from 'shared/hooks';

const SearchBlockMobile = () => {
  const [suggestionsVisible, changeSuggestionVisibility] = useState(false);
  const [inputValue, changeInputValue] = useState('');
  const [suggestions, changeSuggestions] = useState(null);
  const wrapperRef = useRef(null);

  const onClickOutside = useCallback(() => {
    changeInputValue('');
  }, [changeInputValue]);

  useOutsideAlerter(wrapperRef, onClickOutside);

  const handleGetSuggestions = async (inputValue) => {
    try {
      const response = await getSearchSuggestions(inputValue);
      changeSuggestions(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  const debounceFn = useRef(_debounce(handleGetSuggestions, 500));

  const handleChangeValue = (e) => {
    const inputValue = e.target.value;
    changeInputValue(inputValue);
    debounceFn.current(inputValue);
  };

  return (
    <div className="mobile_searchbar_block" ref={wrapperRef}>
      <form className="header_search" id="form_search">
        <SearchBlockInput
          onFocus={() => changeSuggestionVisibility(true)}
          onBlur={() => changeSuggestionVisibility(false)}
          onChange={handleChangeValue}
          value={inputValue}
        />
      </form>

      {inputValue !== '' && suggestions !== null && (
        <SearchSuggestions
          searchedText={inputValue}
          visible={suggestionsVisible}
          suggestions={suggestions}
          onSuggestionClick={() => changeInputValue('')}
        />
      )}
    </div>
  );
};

export default SearchBlockMobile;
